import React from 'react';
import './AISection.css';
import { monitoringCodeExample } from '../../data/codeExamples';

const AISection: React.FC = () => {
  return (
    <section id="ai" className="ai-section">
      <div className="ai-container">
        <div className="ai-header">
          <h2 className="ai-title">Integrate with any AI provider.</h2>
          <p className="ai-description">
            Connect your telephony platform with any AI provider. Build intelligent call routing, 
            voice analytics, and automated customer service solutions with your preferred AI stack.
          </p>
        </div>
        
        <div className="ai-content">
          <div className="ai-info">
            <div className="info-item">
              <h3 className="info-title">AI Integration</h3>
              <p className="info-description">
                Connect with any AI provider through our flexible API. No vendor lock-in, 
                use the AI tools that work best for your business.
              </p>
            </div>
            
            <div className="info-item">
              <h3 className="info-title">Voice Analytics</h3>
              <p className="info-description">
                Real-time voice analysis and sentiment detection. Understand customer emotions 
                and provide better service with AI-powered insights.
              </p>
            </div>
            
            <div className="info-item">
              <h3 className="info-title">Intelligent Routing</h3>
              <p className="info-description">
                AI-powered call routing based on customer intent, agent skills, and business rules. 
                Ensure every call reaches the right person at the right time.
              </p>
            </div>
          </div>
          
          <div className="ai-visual">
            <div className="dashboard-mockup">
              <div className="dashboard-header">
                <div className="dashboard-title">Call Analytics Dashboard</div>
                <div className="dashboard-controls">
                  <div className="control-btn"></div>
                  <div className="control-btn"></div>
                  <div className="control-btn"></div>
                </div>
              </div>
              
              <div className="dashboard-content">
                <div className="chart-section">
                  <div className="chart-title">Call Volume (Last 24h)</div>
                  <div className="chart-bars">
                    {[...Array(12)].map((_, i) => (
                      <div key={i} className="chart-bar" style={{
                        height: `${Math.random() * 60 + 20}%`
                      }}></div>
                    ))}
                  </div>
                </div>
                
                <div className="metrics-section">
                  <div className="metric">
                    <div className="metric-value">1,247</div>
                    <div className="metric-label">Total Calls</div>
                  </div>
                  <div className="metric">
                    <div className="metric-value">98.2%</div>
                    <div className="metric-label">Success Rate</div>
                  </div>
                  <div className="metric">
                    <div className="metric-value">2.3s</div>
                    <div className="metric-label">Avg Response</div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="code-preview">
              <div className="code-title">Real-time Monitoring</div>
              <div className="code-snippet">
                {monitoringCodeExample.nodejs.map((line, index) => (
                  <div key={index} className="code-line">{line}</div>
                ))}
                <div className="code-ellipsis">...</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AISection;
